export const peach = {
    peach100: '#fbf9f7',
    peach200: '#fcf3e9',
    peach300: '#ffe9d0',
    peach400: '#fcdbb5',
    peach500: '#f1d1ac',
    peach600: '#e6c6a1',
    peach700: '#d5b691',
    peach800: '#c1a27e',
    peach900: '#ac8d6a',
    peach1000: '#9f825f',
    peach1100: '#8c6f4d',
    peach1200: '#4e3411',
    peachAccentContrast: '#ffffff',
    peachAccentSurface: '#fdf3ea',
    peachLightest: '#fdf9f4',
    peachLight: '#f9ebdb',
    peach: '#f2d8b8',
    peachDark: '#d1a883',
    peachDarkest: '#715039',
};

export const peachAlpha = {
    peach100: 'rgba(210, 125, 40, 0.02)',
    peach200: 'rgba(252, 138, 10, 0.08)',
    peach300: '#ffe9d0',
    peach400: 'rgba(252, 136, 1, 0.28)',
    peach500: 'rgba(218, 117, 1, 0.32)',
    peach600: 'rgba(192, 104, 3, 0.36)',
    peach700: 'rgba(161, 89, 2, 0.43)',
    peach800: 'rgba(134, 72, 0, 0.5)',
    peach900: 'rgba(114, 61, 0, 0.58)',
    peach1000: 'rgba(103, 56, 0, 0.62)',
    peach1100: 'rgba(92, 50, 2, 0.7)',
    peach1200: 'rgba(65, 38, 0, 0.93)',
    peachAccentContrast: '#ffffff',
    peachAccentSurface: 'rgba(253, 241, 229, 0.8)',
};

export const peachDark = {
    peach100: '#14100d',
    peach200: '#1c1711',
    peach300: '#2d2010',
    peach400: '#3e2604',
    peach500: '#4a300d',
    peach600: '#583e1c',
    peach700: '#6b4f2e',
    peach800: '#846846',
    peach900: '#ffe9d0',
    peach1000: '#f5e0c7',
    peach1100: '#d7b793',
    peach1200: '#f8e2c9',
    peachAccentContrast: '#2e1e0a',
    peachAccentSurface: '#1c170f',
    peachLightest: '#14100d', // peach100
    peachLight: '#1c1711', // peach200
    peach: '#4a300d', // peach500
    peachDark: '#846846', // peach800
    peachDarkest: '#f8e2c9', // peach1200
};

export const peachDarkAlpha = {
    peach100: 'rgba(209, 0, 0, 0.02)',
    peach200: 'rgba(251, 145, 18, 0.05)',
    peach300: 'rgba(255, 145, 9, 0.12)',
    peach400: 'rgba(252, 127, 0, 0.19)',
    peach500: 'rgba(252, 145, 1, 0.24)',
    peach600: 'rgba(253, 167, 54, 0.3)',
    peach700: 'rgba(253, 180, 93, 0.38)',
    peach800: 'rgba(253, 196, 126, 0.49)',
    peach900: 'rgba(254, 232, 206, 0.96)',
    peach1000: 'rgba(254, 216, 172, 0.84)',
    peach1100: 'rgba(255, 232, 207, 0.97)',
    peach1200: 'rgba(38, 28, 14, 0.5)',
    peachAccentContrast: '#2e1e0a',
    peachAccentSurface: 'rgba(38, 28, 14, 0.5)',
};
